<template>
  <div class="appointment-type">
    <div class="heading-appoitment emt-6" @click="toggleView">
      Personal Info
      <span class="icon-acc-down" :class="{ rotate: show }">
        <img src="../../../assets/img/icon-accordion-down.png" alt="Expand" />
      </span>
    </div>

    <transition
      name="expand"
      @before-enter="beforeEnter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @after-leave="afterLeave"
    >
      <!-- First name -->
      <div ref="cust" v-show="show">
        <div ref="firstNameDiv" class="input-wrapper position-relative first">
          <span class="ver-center">
            <span class="mandatory">*</span>First Name
          </span>
          <div class="pl-100">
            <input
              ref="firstNameInput"
              @input="setFirstName($event.target.value)"
              :value="name.firstName"
              type="text"
              class="title mb-0 pb-0 font-16"
              autocomplete="off"
            />
          </div>
        </div>

        <!-- Last name -->
        <div ref="lastNameDiv" class="input-wrapper position-relative first">
          <span class="ver-center">
            <span class="mandatory">*</span>Last Name
          </span>
          <div class="pl-100">
            <input
              ref="lastNameInput"
              @input="setLastName($event.target.value)"
              :value="name.lastName"
              type="text"
              class="title border-b-none mb-0 pb-0 font-16"
              autocomplete="off"
            />
          </div>
        </div>

        <template v-if="birthdayNeeded">
          <!-- Line 1 -->
          <div ref="streetDiv" class="input-wrapper position-relative first">
            <span class="ver-center">Street</span>
            <div class="pl-100">
              <input
                ref="streetInput"
                @input="setPhaLine1($event.target.value)"
                :value="address.pha_line1"
                type="text"
                class="title mb-0 pb-0 font-16"
                autocomplete="off"
              />
            </div>
          </div>

          <!-- Line 2 -->
          <div ref="aptDiv" class="input-wrapper position-relative first">
            <span class="ver-center">Apt, etc</span>
            <div class="pl-100">
              <input
                ref="aptInput"
                @input="setPhaLine2($event.target.value)"
                :value="address.pha_line2"
                type="text"
                class="title mb-0 pb-0 font-16"
                autocomplete="off"
              />
            </div>
          </div>

          <!-- City -->
          <div ref="cityDiv" class="input-wrapper position-relative first">
            <span class="ver-center">City</span>
            <div class="pl-100">
              <input
                ref="cityInput"
                @input="setPhaCity($event.target.value)"
                :value="address.pha_city"
                type="text"
                class="title mb-0 pb-0 font-16"
                autocomplete="off"
              />
            </div>
          </div>

          <!--State-->
          <div ref="stateDiv" class="input-wrapper position-relative first">
            <span class="ver-center">State</span>
            <div class="pl-100">
              <input
                ref="stateInput"
                :value="state"
                @focus="showStateInner = true"
                @input="setStateCodeLocal($event.target.value)"
                @blur="showStateInnerFalse"
                type="text"
                class="title mb-0 pb-0 font-16"
                autocomplete="off"
              />
            </div>

            <!-- Inner -->
            <transition name="expand-real">
              <div class="state-expand" v-show="showStateInner">
                <ul>
                  <li
                    v-for="stateCode in filteredStateCodes"
                    :key="stateCode.id"
                    @mousedown="setStateCodeLocal(stateCode.state)"
                    @click="setStateCodeLocal(stateCode.state)"
                  >
                    {{ stateCode.state }}
                  </li>
                </ul>
              </div>
            </transition>
          </div>

          <!--Zip-->
          <div
            ref="postalCodeDiv"
            class="input-wrapper position-relative first"
          >
            <span class="ver-center">Zip</span>
            <div class="pl-100">
              <input
                ref="postalCodeInput"
                @input="setPhaPostalCode($event.target.value)"
                :value="address.pha_postalCode"
                type="text"
                class="title mb-0 pb-0 font-16"
                autocomplete="off"
              />
            </div>
          </div>

          <!--Birtday--->
          <div ref="birthDiv" class="birthday-wrapper">
            <div
              class="input-wrapper border-b-none awsome-wrapper starts-appoitment all-day-wrapper show-awsome-select"
            >
              <div class="title-wrapper position-relative">
                <span class="ver-center">
                  <span class="mandatory">*</span>Birthday
                </span>
              </div>
              <div class="content-wrapper position-relative">
                <div
                  class="ver-center show-awsome-select calendar-wrapper text-right toggle-calendar full-width"
                >
                  <input
                    ref="birthInput"
                    :value="formattedDate"
                    @change="changeDate"
                    type="date"
                    name="start-time"
                    class="text-only-input ml-10 mb-0 pb-0 font-16"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin";
import { mapMutations, mapGetters } from "vuex";

export default {
  mixins: [dateAndTimeMixin],
  data() {
    return {
      showStateInner: false,
      state: "",
      allRefs: [
        "firstName",
        "lastName",
        "street",
        "apt",
        "city",
        "state",
        "postalCode",
        "birth"
      ]
    };
  },
  computed: {
    ...mapGetters("addNew", {
      name: "getName",
      address: "getAddress",
      date: "getBirthDate",
      stateCodes: "getStateCodes"
    }),
    formattedDate() {
      return this.formatDate({
        dayOfMonth: this.date.dayOfMonth,
        month: this.date.month,
        year: this.date.year
      });
    },
    filteredStateCodes() {
      return this.stateCodes.filter(code => {
        return (
          code.state.toLowerCase().search(escape(this.state.toLowerCase())) !==
          -1
        );
      });
    },
    firstName() {
      return this.name.firstName.replace(/&amp;/g, "&");
    },
    lastName() {
      return this.name.lastName.replace(/&amp;/g, "&");
    }
  },
  props: {
    birthdayNeeded: Boolean,
    show: {
      type: Boolean,
      default: true
    },
    view: {
      type: [Function, Boolean],
      default: false
    },
    hide: {
      type: [Function, Boolean],
      default: false
    }
  },
  methods: {
    ...mapMutations("addNew", {
      setDate: "setBirthDate",
      setFirstName: "setFirstName",
      setLastName: "setLastName",
      setPhaLine1: "setPhaLine1",
      setPhaLine2: "setPhaLine2",
      setPhaCity: "setPhaCity",
      setPhaState: "setPhaState",
      setPhaPostalCode: "setPhaPostalCode"
    }),
    setStateCodeLocal(value) {
      // Step 1: Check if the value is different. If not return
      if (this.state === value) {
        return;
      }
      this.state = value;

      // Step 2: Default id is set to 0
      let id = -1;

      // Step 3: If length is not 2 set the state code to 0
      if (value.length !== 2) {
        if (value === "") {
          this.setPhaState(0);
        } else {
          this.setPhaState(-1);
        }
        return;
      }

      // Step 4: Get the id from the code
      for (let i = 0; i < this.stateCodes.length; i++) {
        let code = this.stateCodes[i];
        if (code.state.toLowerCase() === value.toLowerCase()) {
          id = code.id;
          break;
        }
      }

      // Step 5: Set the state code in the global state
      this.setPhaState(id);
    },
    showStateInnerFalse() {
      setTimeout(() => {
        this.showStateInner = false;
      }, 0);
    },
    toggleView() {
      if (this.view && this.hide) {
        if (this.show) {
          this.hide();
        } else {
          this.view();
        }
      }
    },
    changeDate(event) {
      // Step 1: Generate the proper format for setting the date
      const date = event.target.value.split("-");
      const year = parseInt(date[0]);
      const month = parseInt(date[1]) - 1;
      const day = parseInt(date[2]);

      // Step 2: Setting the date in the global vue js state
      if (!isNaN(day) && !isNaN(month) && !isNaN(day)) {
        this.setDate({
          dayOfMonth: day,
          month: month,
          year: year
        });
      }
    },
    beforeEnter() {
      this.$refs.cust.classList.add("cust");
    },
    beforeLeave() {
      this.$refs.cust.classList.add("cust");
    },
    afterEnter() {
      this.$refs.cust.classList.remove("cust");
    },
    afterLeave() {
      this.$refs.cust.classList.remove("cust");
    },
    /**
     * For search
     */
    escape(s) {
      // eslint-disable-next-line no-useless-escape
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
  },
  created() {
    setTimeout(() => {
      if (this.address.pha_state !== 0) {
        for (let i = 0; i < this.stateCodes.length; i++) {
          if (this.stateCodes[i].id === this.address.pha_state) {
            this.state = this.stateCodes[i].state;
          }
        }
      }
    });
    this.setFirstName(this.name.firstName.replace(/&amp;/g, "&"));
    this.setLastName(this.name.lastName.replace(/&amp;/g, "&"));
  },
  mounted() {
    this.$nextTick(() => {
      for (let i = 0; i < this.allRefs.length; i++) {
        let currElem = this.allRefs[i];
        if (this.$refs[currElem + "Div"] === undefined) {
          break;
        }
        this.$refs[currElem + "Div"].addEventListener("click", () => {
          this.$refs[currElem + "Input"].focus();
          this.$refs[currElem + "Input"].click();
        });
      }
    });
  }
};
</script>

<style scoped>
.input-wrapper input {
  border: none !important;
}

.first {
  border-bottom: 1px solid #f2f2f2 !important;
}

.cust {
  clear: both;
  overflow: hidden;
}

.expand-leave-active {
  animation: contract 0.3s ease-in-out forwards;
}

.expand-enter-active {
  animation: expand 0.3s ease-in-out forwards;
}

.expand-real-leave-active {
  animation: contract-real 0.3s ease-in-out forwards;
}

.expand-real-enter-active {
  animation: expand-real 0.3s ease-in-out forwards;
}

div.state-expand {
  position: absolute;
  background-color: white;
  z-index: 99;
  left: 40%;
  bottom: -70px;
  box-shadow: 0px 5px 7px lightgray;
  padding: 10px 0px;
  max-height: 200px;
  overflow: auto;
}

div.state-expand ul {
  padding: 0px;
}

div.state-expand ul li {
  padding: 10px 75px;
  list-style: none;
  cursor: pointer;
}

div.state-expand ul li:hover {
  background-color: #eeeeee;
}

@keyframes expand-real {
  from {
    opacity: 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

@keyframes contract-real {
  from {
    opacity: 1;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform: scaleY(0);
  }
}

@keyframes expand {
  from {
    opacity: 0;
    height: 0px;
  }
  to {
    opacity: 1;
    height: 317px;
  }
}

@keyframes contract {
  from {
    opacity: 1;
    max-height: 317px;
  }
  to {
    opacity: 0;
    max-height: 0;
  }
}
</style>
